<div class="team-picture">
  T
</div>